import type { Theme } from '@mui/material/styles';

type ThemeWithVars = Theme & { vars: { palette: Theme['palette'] } };

/**
 * Returns the CSS-variable palette (`theme.vars.palette`) of a CSS-variables theme.
 *
 * Use it inside sx/style callbacks when a color has to be embedded into a non-color
 * CSS property (e.g. `filter`, `drop-shadow`) or passed to a non-MUI consumer
 * (e.g. react-select), where a `'palette.token'` string cannot be resolved by MUI.
 * The returned values are `var(--mui-palette-*)` references, keeping the CSS-variable
 * indirection instead of a build-time resolved literal.
 */
export const getVarsPalette = (theme: Theme) => (theme as ThemeWithVars).vars.palette;
